import { gql } from 'apollo-angular';

export const CREATE_BRANCH = gql`
  mutation createBranch($input: CreateBranchInput!) {
    createBranch(createBranchInput: $input) {
      id
      branchName
    }
  }
`;

export const UPDATE_BRANCH = gql`
  mutation updateBranch($id: Int!, $updateBranchInput: UpdateBranchInput!) {
    updateBranch(id:$id,updateBranchInput: $updateBranchInput)  {
    id
    branchName
  }
  }
`;

export const REMOVE_BRANCH_BY_ID = gql`
mutation removeBranch($id: Int!) {
  removeBranch(id: $id)
}
`;